<template functional>
  <div class="form-group">
    <slot></slot>
    <div class="error" v-if="props.errorMessage">
      <small>{{props.errorMessage}}</small>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: String, default: null },
    errorMessage: {
      type: String,
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';
@import '~bootstrap/scss/forms';

.form-group {
  margin-bottom: $spacer * 1.5;
}

.error {
  float: right;
  color: red;
}

.is-valid {

}
</style>
